import { changeSearchParamByKey } from '@skytech/utils'
import { useLocation, useNavigate } from 'react-router-dom'

export const useSearchParamsByKey = (queryString: string, defaultValue?: string) => {
  const navigate = useNavigate()
  const location = useLocation()

  return changeSearchParamByKey({
    queryString,
    defaultValue,
    search: location.search,
    navigate,
  })
}
